import React from 'react';
import resume from '../../assets/documents/Juan_Ansaldo_Resume.pdf';
import './styles/Navbar.css';

const Navbar = () => {
  return (
    <header className="portfolio-header">
      <h1>Juan Ansaldo</h1>
      <nav>
        <a 
          href={resume}
          target="_blank"
          rel="noopener noreferrer"
          className="social-link"
        >
          Resume
        </a>
        <a
          href="mailto:juanansaldo@outlook.com"
          target="_blank" 
          rel="noopener noreferrer"
          className="social-link"
        >
          Email
        </a>
        <a 
          href="https://www.linkedin.com/in/juan-ansaldo-193073182" 
          target="_blank" 
          rel="noopener noreferrer"
          className="social-link"
        >
          LinkedIn
        </a>
        <a 
          href="https://github.com/juanansaldo" 
          target="_blank" 
          rel="noopener noreferrer"
          className="social-link"
        >
          GitHub
        </a>
      </nav>
    </header>
  );
};

export default Navbar;